import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  filterDropdown: {
    padding: '0',
    margin: '0',
    minWidth: '40px'
  },
  sortAscOption: {
    '& .MuiSvgIcon-root': {
      transform: 'rotate(180deg)'
    }
  },
  returnFromSecondFilterLevel: {
    '& .MuiSvgIcon-root': {
      transform: 'rotate(90deg)'
    }
  },
  filterMultiselectContainer: {
    maxHeight: '340px',
    overflow: 'auto',
    width: '350px'
    // boxShadow: 'inset 0px -7px 20px -15px rgba(66, 68, 90, 0.65)',
  },
  filterMultiselectItem: {
    '& .MuiListItemText-root': {
      maxWidth: '85%'
    }
  },
  filterOptionsPropertiesSubHeader: {
    padding: '2px 16px'
  },
  filterByPortfoliosOption: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: '0'
  },
  searchField: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    }
  },
  secondLevelActionBtns: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 16px'
  },
  dividerNoTopMargin: {
    marginTop: '0 !important'
  },
  dividerNoBottomMargin: {
    marginBottom: '0 !important'
  }
});
export default useStyles;